export default "__VITE_ASSET__Du9KBDlw__"